import { render, staticRenderFns } from "./AnxParagraph.vue?vue&type=template&id=7dcab4fe&scoped=true&"
import script from "./AnxParagraph.vue?vue&type=script&lang=ts&"
export * from "./AnxParagraph.vue?vue&type=script&lang=ts&"
import style0 from "./AnxParagraph.vue?vue&type=style&index=0&id=7dcab4fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcab4fe",
  null
  
)

export default component.exports